import * as cardValidator from "card-validator";
import * as validation from "./validation";

export function number(cardNum: string) {
  return cardValidator.number(cardNum);
}

export function ruleNumber(message: string, optional?: boolean) {
  return (cardNum: string) => {
    return (validation.isEmpty(cardNum) && optional) || number(cardNum).isValid || message;
  };
}

export function ruleExpiration(message: string, optional?: boolean) {
  return (value: string) => {
    return (validation.isEmpty(value) && optional) || cardValidator.expirationDate(value).isValid || message;
  };
}

export function maskNumber(cardNumber: string): string {
  let panMaxLength = 19;
  let gaps = [] as number[];
  const cv = number(cardNumber);
  if (cv && cv.card) {
    gaps = cv.card.gaps || [];
    const maxLen = (cv.card.lengths || []).reduce((val1, val2) => (val1 > val2 ? val1 : val2), 0);
    if (maxLen > 0) {
      panMaxLength = maxLen;
    }
  }
  return makePANMask(gaps, panMaxLength);
}

function makePANMask(gaps: number[], maxLength: number): string {
  const allGaps = [...gaps, maxLength];
  let mask = "";
  let lastIdx = 0;
  for (let i = 0; i < allGaps.length; i++) {
    const idx = allGaps[i];
    for (let j = 0; j < idx - lastIdx; j++) {
      mask += "#";
    }
    lastIdx = idx;
    if (i !== allGaps.length - 1) {
      mask += " ";
    }
  }
  return mask;
}
